import { useMemo } from "react";

import { useTabsRules } from "@/hooks/useTabsRules/useTabsRules";
import { SUB_ROUTES } from "../TabMenu/TabMenu.constants";
import { SubRoute } from "../TabMenu/TabMenu.decl";

export function useTabs() {
  const {
    shouldDisableInsightsTab,
    shouldDisableEvaluationTab,
    shouldHideEvaluationTab,
    shouldHideInsightsTab,
    shouldRedirectInsights,
  } = useTabsRules();

  const hiddenTabs = useMemo(() => {
    const res: SubRoute[] = [];

    if (shouldHideEvaluationTab) {
      res.push("evaluation");
    }

    if (shouldHideInsightsTab) {
      res.push("insights");
    }

    return res;
  }, [shouldHideEvaluationTab, shouldHideInsightsTab]);

  const disabledTabs = useMemo(() => {
    const res: SubRoute[] = [];

    if (shouldDisableInsightsTab && !shouldHideInsightsTab) {
      res.push("insights");
    }

    if (shouldDisableEvaluationTab) {
      res.push("evaluation");
    }

    return res;
  }, [
    shouldDisableInsightsTab,
    shouldDisableEvaluationTab,
    shouldHideInsightsTab,
  ]);

  const tabs = useMemo(
    () => SUB_ROUTES.filter((route) => !hiddenTabs.includes(route)),
    [hiddenTabs]
  );

  return {
    tabs,
    disabledTabs,
    shouldRedirectInsights,
  };
}
